import { filterLang, filterDate, filterNotesType, filterSize, formatDate } from './filters'

import cookie from 'js-cookie'
import element from './mixins/element'
import api from '@/axios'

export default {
  install(Vue, options) {
    //  数据格式化
    Vue.filter('filterLang', filterLang)
    Vue.filter('filterDate', filterDate)
    Vue.filter('filterNotesType', filterNotesType)
    Vue.filter('filterSize', filterSize)
    Vue.filter('formatDate', formatDate)

    //  api && cookie
    Vue.prototype.$http = api
    Vue.prototype.$cookie = cookie

    Vue.prototype.$local = {
      get(name) {
        let value = localStorage.getItem(name)
        if (/^\{.*\}$/.test(value)) {
          value = JSON.parse(value)
        } else if (!value) {
          value = false
        }
        return value
      },
      set(name, value) {
        if (typeof value === typeof {}) value = JSON.stringify(value)
        return localStorage.setItem(name, value)
      },
      remove(name) {
        return localStorage.removeItem(name)
      },
      clear() {
        return localStorage.clear()
      }
    }

    Vue.mixin(element)

    // 防重复点击(指令实现)
    const pointDoms = [] // 使用这个指令的所有DOM对象
    Vue.directive('preventReClick', {
      inserted(el, binding) {
        pointDoms.push(el) // 存储使用这个指令的DOM
        el.addEventListener('click', () => {
          // 禁用所有使用这个指令的DOM结构点击事件
          pointDoms.forEach(pointItem => {
            pointItem.style.pointerEvents = 'none'
          })
          setTimeout(() => {
            // 启动所有使用这个指令的DOM结构点击事件
            pointDoms.forEach(pointItem => {
              pointItem.style.pointerEvents = 'auto'
            })
          }, binding.value || 0)
        })
      }
    })

    //  取消生产提示
    Vue.config.productionTip = false
  }
}

/**
 * 判断当前设备是否为移动端
 * @returns {boolean}
 */
export function isMobileDevice() {
  const userAgent = navigator.userAgent.toLowerCase()

  // 匹配移动设备关键词（覆盖99%的移动端场景）
  const mobileKeywords = [
    'android',
    'iphone',
    'ipod',
    // 'ipad',
    'windows phone',
    'blackberry',
    'webos',
    'opera mini',
    'iemobile',
    'mobile'
  ]

  // 排除iPad的桌面模式（iPadOS 13+默认使用桌面UA）
  const isiPadDesktopMode = /macintosh/.test(userAgent) && navigator.maxTouchPoints > 1

  return (
    mobileKeywords.some(keyword => userAgent.includes(keyword)) ||
    // 支持触控的非移动设备（如Surface）按需处理
    ('ontouchstart' in window && !isiPadDesktopMode)
  )
}
